module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "id": "p9"
    }
  }, [_c('h1', {
    staticClass: "color-45271F font-Arial-3"
  }, [_vm._v("01")]), _vm._v(" "), _c('p', {
    staticClass: "running_txt color-FF5100 font-Arial-1_5"
  }, [_vm._v("Like so many Dads, I love to grill. Perhaps it’s being so close to the fire that harkens back to an earlier, simpler time—before, say, income tax or Jerry Springer. The grill is, after all, just a man, a pair of tongs, and heat.")]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-14"
  }, [_vm._v("When the weather gets warm, when the birds start chirping and the crocus buds appear, I feel a powerful force pulling me inexorably toward the backyard. And since the hammock isn’t up yet, it must be that it is pulling me to my trusty grill. For the next few months, whenever it’s not raining (or at least not raining hard) I will try to cook dinner not in the kitchen, but outside on the grill. Spring means it’s time for Dad to get out of the frying pan and start up the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-14"
  }, [_vm._v("Like so many dads, I love to barbecue. When I’m standing at the grill, I’m in charge. It’s my fiefdom and I’m the fief, unlike, for instance, in pretty much every other room in the house except the garage, and even there I’ve now been relegated to the bottom half of the shelf unit (which ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumItalic-6_1-15"
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-14"
  }, [_vm._v("assembled, by the way), the top being dedicated to an arsenal of paper towels, apparently, in anticipation of an oil tanker accidentally overturning on our block.")])])]), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-14"
  }, [_c('a', {
    attrs: {
      "id": "p9"
    }
  }, [_vm._v("I especially enjoy having The Progeny watch me at the grill, working my magic with the charcoal. They’ve seen their Dad cooking plenty of times, but in the kitchen, it always feels as though something could go wrong. Cooking at the stove, I’m a bit frenetic, as if I’m always playing catch-up. At the grill, however, I’m at ease. I’ve got game. I’m smooth, I’m casual—as dexterous with the tongs as Chris Paul is with a basketball. I’ve got a good handle. ")]), _c('a', {
    attrs: {
      "id": "p10"
    }
  }, [_vm._v(" And I take everything in stride, the way a dad is supposed to. If some fat from the ")]), _c('span', {
    attrs: {
      "href": "#/html/063chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#009DE0"
    }
  }, [_vm._v("Chicken Thighs Cubano")])]), _vm._v(" hits the coals and produces a momentary burst of flame, do I flinch? Do I startle back like a rookie facing his first big league curveball? No sir. I’m calm. Relaxed. Nonplussed (or plussed—I never remember which one means dealing with adversity with casual, Dirty Harry–like disdain). Because the grill is Dad’s domain, whence he fills platters with perfectly cooked burgers and ears of corn that sport their grill marks as proudly as Tom Brady does the black paint under his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-14"
  }, [_vm._v("And though I mean this in the nicest way, it must be said that the grill is also an oasis from Mom. Anything I cook in the kitchen is naturally compared with Mom’s version. No matter how hard I try, whatever I make is either “not as good as Mom’s” or “ just as good as Mom’s.” Either way, I’m deep in her gastronomic shadow. But the grill is Mom-proof. My efforts are compared only to the last time I barbecued, which, I have to admit, was pretty darn good.")]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-14"
  }, [_vm._v("And sometimes The Progeny even venture out and share the grill with me. There have even been afternoons when we have segued directly from the ball field to the grill, putting down our baseball mitts and donning our oven mitts as we addressed the phalanx of sizzling skirt steaks and slices of red onion for our dinner of "), _c('span', {
    attrs: {
      "href": "#/html/028chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#009DE0"
    }
  }, [_vm._v("Skirt Steak Fajitas")])]), _vm._v(". Or sometimes we’ll stand shoulder to shoulder, mopping the "), _c('span', {
    attrs: {
      "href": "#/html/115chapter101",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#009DE0"
    }
  }, [_vm._v("Smoked Baby-Back Ribs")])]), _vm._v(" with their final coating of sauce or giving the "), _c('span', {
    attrs: {
      "href": "#/html/055chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#009DE0"
    }
  }, [_vm._v("Lamb and Merguez Kabobs")])]), _vm._v(" a final quarter-turn. If Norman Rockwell were to drive by, he would surely jam on his brakes and whip out his sketchpad.")]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image color-3C1C00 font-AtmaSerif-MediumRoman-5_1-14"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9780811866989_i0004.jpg",
      "src": "images/e9780811866989_i0004.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image color-3C1C00 font-AtmaSerif-MediumRoman-5_1-14"
  }, [_c('a', {
    attrs: {
      "id": "p11"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9780811866989_i0005.jpg",
      "src": "images/e9780811866989_i0005.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "p11"
    }
  }, [_c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-14"
  }, [_vm._v("The barbecue was made for Dad. It serves as a kind of sanctuary. Standing before the hot coals, he is insulated from spousal and parental demands that can sometimes be overwhelming. “Sorry, Honey, I can’t clean up the basement now—I’m grilling!” Unlike the many vicissitudes of Fatherhood, not much can go wrong at the grill. It has few moving parts. Keep your grill grate clean and the vents open and barbecuing is simpler than checkers. Remember to fill the propane tank and you’ll find there are more surprises in a game of Go Fish. The principal tool you use is a pair of tongs, which so mirrors the function of the human hand that even the most instruction-phobic dad can use them.")])]), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-14"
  }, [_c('a', {
    attrs: {
      "id": "p11"
    }
  }, [_vm._v("But most reassuring of all is how easy it is to cook on the grill. For the most part, there’s step A and then there is step A again. ")]), _c('span', {
    attrs: {
      "href": "#/html/088chapter76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#009DE0"
    }
  }, [_vm._v("Foolproof Burgers")])]), _vm._v(" require one turn after 4 ½ minutes and then removal from the grill after 4 ½ minutes more. "), _c('span', {
    attrs: {
      "href": "#/html/078chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#009DE0"
    }
  }, [_vm._v("Miso-Ginger Marinated Grilled Salmon")])]), _vm._v(" gets flipped after 5. More than culinary expertise, you need patience and decisiveness when you grill. You need resolve. It also happens to be good practice for parenting a teenager.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7178160c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/006chapter01.vue
// module id = 72
// module chunks = 0